import { Route } from "react-router-dom";
import PageTitle from "../misc/PageTitle";
import { CalculationsList } from "./CalculationsList";
import { EditCalculationPage } from "./EditCalculationPage";
import { NewCalculationPage } from "./NewCalculationPage";

export function CalculationsRoutes2() {
  return (
    <Route path="calculations">
      <Route
        index
        element={
          <>
            <PageTitle title="lista kalkulacji" />
            <CalculationsList />
          </>
        }
      />
      <Route
        path="new"
        element={
          <>
            <PageTitle title="nowa kalkulacja" />
            <NewCalculationPage />
          </>
        }
      />
      <Route
        path=":calculationId"
        element={
          <>
            <PageTitle title="szczegóły kalkulacji" />
            <EditCalculationPage />
          </>
        }
      />
    </Route>
  );
}
